import { cookieLangName, getCookie } from '@root/src/cookie';
import { HttpClient } from '@root/src/lib/HttpClient';
const language = getCookie(cookieLangName) || 'vn';
const prefix = '/category';

function normalizeAppearUrl(value: string) {
  const normalized = value.trim().replace(/\/+$/, '');
  return normalized;
}

function resolveAppear(appear?: string) {
  if (appear && appear !== 'undefined' && appear !== 'null') {
    return normalizeAppearUrl(appear);
  }
  if (process.env.NEXT_PUBLIC_APPEAR) {
    return normalizeAppearUrl(process.env.NEXT_PUBLIC_APPEAR);
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return normalizeAppearUrl(window.location.origin);
  }
  return '';
}

export async function getAllCategory(currentPage?: number, appear?: string) {
  try {
    const pageParam = currentPage ? `&currentPage=${currentPage}` : '';
    const appearValue = resolveAppear(appear);
    const appearParam = appearValue
      ? `&appear=${encodeURIComponent(appearValue)}`
      : '';
    const data = await HttpClient.httpGet(
      `${prefix}?lang=${language}${appearParam}${pageParam}`
    );
    return data;
  } catch (error) {
    console.error('Error fetching categories:', error);
    return { success: false, data: [] };
  }
}

export async function getCategoryBySlug(slug: string) {
  try {
    const appearValue = resolveAppear();
    const appearParam = appearValue
      ? `&appear=${encodeURIComponent(appearValue)}`
      : '';
    const data = await HttpClient.httpGet(
      `${prefix}/slug/${slug}?lang=${language}${appearParam}`
    );
    return data;
  } catch (error) {
    console.error('Error fetching category by slug:', error);
    return 'not ok';
  }
}

export async function getProductsByCategorySlug(
  slug: string,
  page,
  pageSize,
  appear?: string
) {
  const language = getCookie(cookieLangName) || 'vn';
  try {
    const appearValue = resolveAppear(appear);
    const appearParam = appearValue
      ? `&appear=${encodeURIComponent(appearValue)}`
      : '';
    const data = await HttpClient.httpGet(
      `${prefix}/slug/${slug}/products?currentPage=${page}&lang=${language}&pageSize=${pageSize}${appearParam}`
    );
    // console.log(data)
    return data;
  } catch (error) {
    console.error('Error fetching product by ID:', error);
    return null;
  }
}
